<div class="superadmin-popup">
    
    <h4 class="dialog-title text-center">{{ 'Edit Sensor' | translate }}</h4>

    <hr />

    <div class="mb-4">
        <div mat-dialog-content>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <mat-label>{{ 'Device ID' | translate }}</mat-label>
                        <input matInput [(ngModel)]="data.id" readonly class="cursor-not-allowed"
                            [title]="'Device ID cannot be changed' | translate" />
                        <mat-icon matPrefix class="mr-3">
                            <i class="fas fa-broadcast-tower"></i>
                        </mat-icon>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field>
                        <mat-label>{{ 'Device Name' | translate }}</mat-label>
                        <input matInput [(ngModel)]="data.name" required />
                        <mat-icon matPrefix class="mr-3">
                            <i class="fas fa-tag"></i>
                        </mat-icon>
                        <mat-error>{{ 'Device Name is required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-button class="btn button-primary" (click)="save()" [class.button-spinner]="isLoading"
                [disabled]="!data.name || isLoading">{{ 'Save' | translate }}</button>

            <button mat-button class="btn button-accent" mat-dialog-close>{{ 'Cancel' | translate }}</button>
        </div>
    </div>
</div>
